import { lang } from '@umu/ukit-lang';
import { DataNode } from 'rc-tree/lib/interface';
import { ICategory, IDataInfo, ISearchParams, SOURCE_DATA_TYPE, SOURCE_IMG_TYPE } from '../interface';
import { unescapeHtml } from '@umu/umu-util';
import { SESSION_TYPE_NAMES } from 'common/src/config';
const DEFAULT_PAGE = 1;

const defaultList: IDataInfo = {
    list: [],
    page_info: {
        current_page: 1,
        list_total_num: 0,
        total_num: 0,
        size: 20,
        total_page_num: 0,
    },
};
const sourceImgTypeMap = {
    [SOURCE_DATA_TYPE.CIRCLE]: SOURCE_IMG_TYPE.CUSTOM,
    [SOURCE_DATA_TYPE.COURSE]: SOURCE_IMG_TYPE.CUSTOM,
    [SOURCE_DATA_TYPE.LECTURER]: SOURCE_IMG_TYPE.AVATAR,
    [SOURCE_DATA_TYPE.MICRO_PAGES]: SOURCE_IMG_TYPE.CUSTOM,
    [SOURCE_DATA_TYPE.PRACTICE_CHNNEL]: SOURCE_IMG_TYPE.CUSTOM,
    [SOURCE_DATA_TYPE.PRACTICE_OBJ]: SOURCE_IMG_TYPE.CUSTOM,
    [SOURCE_DATA_TYPE.OUTER_URL]: SOURCE_IMG_TYPE.CUSTOM,
    [SOURCE_DATA_TYPE.PROGRAM]: SOURCE_IMG_TYPE.CUSTOM,
    [SOURCE_DATA_TYPE.SESSION]: SOURCE_IMG_TYPE.SESSION,
};
const knowledgeTYpeList = [SOURCE_DATA_TYPE.COURSE, SOURCE_DATA_TYPE.PROGRAM, SOURCE_DATA_TYPE.SESSION];
interface IOptionItem {
    value: string;
    label: string;
}
const getSessionList = (excludeList: number[], extentArr?: IOptionItem[]) => {
    const result: IOptionItem[] = [];
    for (const key in SESSION_TYPE_NAMES) {
        if (excludeList.indexOf(Number(key)) !== -1) {
            continue;
        }
        result.push({
            value: String(key),
            label: SESSION_TYPE_NAMES[key],
        });
    }
    return (extentArr || []).concat(result);
};
const tabParams = [
    {
        key: SOURCE_DATA_TYPE.COURSE,
        tab: lang('课程'),
    },
    {
        key: SOURCE_DATA_TYPE.PROGRAM,
        tab: lang('学习项目'),
    },
    {
        key: SOURCE_DATA_TYPE.SESSION,
        tab: lang('小节'),
    },
    {
        key: SOURCE_DATA_TYPE.LECTURER,
        tab: lang('讲师'),
    },
    {
        key: SOURCE_DATA_TYPE.MICRO_PAGES,
        tab: lang('微页面'),
    },
];
const getTreeData = (list: ICategory[]): DataNode[] => {
    return list.map((item: ICategory) => {
        const isNode = item.sub_category && !!item.sub_category.length;
        let numText = '';
        if (item.course_num) {
            numText = ` (${item.course_num})`;
        }
        const result: DataNode = {
            key: item.id,
            title: `${unescapeHtml(item.name)}${numText}`,
        };
        if (isNode) {
            result.children = getTreeData(item.sub_category);
        }
        return result;
    });
};
const defaultParams: ISearchParams = {
    program_title: '',
    group_title: '',
    session_title: '',
    session_type: '',
    keyword: '',
    uids: '',
    category_id: '',
    enterprise_group_ids: '',
    department_ids: '',
};

export {
    tabParams,
    knowledgeTYpeList,
    sourceImgTypeMap,
    DEFAULT_PAGE,
    defaultList,
    defaultParams,
    getSessionList,
    getTreeData,
};
